export default __webpack_public_path__ + "static/media/010-caravan-1.03b45205.png";